import request from "@/utils/request";

export function searchICSelector(params) {
  return request({
    url: "/product/ic_selector/",
    method: "get",
    params,
  });
}

export function getProductTypeByID(params, id) {
  return request({
    url: "/product/product_types/" + id + "/",
    method: "get",
    params,
  });
}

export function getAccessoryByID(params, id) {
  return request({
    url: "/product/accessory_types/" + id + "/",
    method: "get",
    params,
  });
}
